import React from 'react';
import '../../assets/css/DefaultSections.css';

const Devider = () => {

    return (
        <div className="section-devider"/>
    );

}

export default Devider;